module.exports = __webpack_public_path__ + "img/full_line_shape.d335b7c4.png";